import styled from 'styled-components';

import { theme } from '../../global';

export const MainContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 32px;

  @media (max-width: 1358px) {
    gap: 0;
  }
`;

export const MainContentWrapper = styled.div`
  max-width: ${theme.content.max_width};
  width: 100%;
  padding-top: 8px;
`;
